export class TicketPrintRequest {
  ticketId: number;
  reprintFlag: boolean;
  requestId: string;
  ticketPrintQueue: string;
  sendOrderEmails: boolean;
  sendCopiesOverride: boolean;

  constructor(
    ticketId: number,
    reprintFlag: boolean,
    requestId: string,
    selectedPrinter: string,
    sendOrderEmails?: boolean,
    sendCopiesOverride?: boolean
  ) {
    this.ticketId = ticketId;
    this.reprintFlag = reprintFlag;
    this.requestId = requestId;
    this.ticketPrintQueue = selectedPrinter;
    this.sendOrderEmails = sendOrderEmails ?? false;
    this.sendCopiesOverride = sendCopiesOverride ?? false;
  }
}

export class TicketEmailRequest {
  ticketId: number;
  requestId: string;

  constructor(ticketId: number, requestId: string) {
    this.ticketId = ticketId;
    this.requestId = requestId;
  }
}
